import { ApiClientProps } from "hooks/useApi";

export interface Location {
  id?: number | string;
  locationId?: string;
  name?: string | null;
  enabled?: boolean;
  partnerId?: string;
  tableStatusEnabled?: boolean;
  checkMatchEnabled?: boolean;
  partnerVenueId?: string;
  posType: string;
}

async function updateLocation(
  {
    id,
    locationId,
    name,
    enabled,
    tableStatusEnabled,
    checkMatchEnabled,
    posType,
    partnerId,
    partnerVenueId,
  }: Location,
  apiClient: ApiClientProps
): Promise<Location[]> {
  if (!id || !locationId || !posType || !partnerId) {
    throw new Error(
      "Network failure. Please check your connection and ensure your request includes all required parameters."
    );
  }

  const body = JSON.stringify({
    locationId,
    name,
    enabled,
    tableStatusEnabled,
    checkMatchEnabled,
    partnerVenueId,
    posType,
  });

  return await apiClient.put({
    path: `/middleware-admin/partners/${partnerId}/locations/${id}`,
    headers: {
      "Content-Type": "application/json",
      partnerKey:
        posType === "omnivore" ? "omnivore-stage" : "resy-prod-sample",
    },
    body,
  });
}

export default updateLocation;
